import React, { useEffect, useId, useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';

export const MerchantPaymentSearch: React.FC<{
    value: string;
    onSearch: (value: string) => void;
}> = ({ value, onSearch }) => {
    const id = useId();
    const [draft, setDraft] = useState(value);
    useEffect(() => setDraft(value), [value]);

    return (
        <form className="space-y-2" onSubmit={event => {
            event.preventDefault();
            const query = draft.trim();
            setDraft(query);
            onSearch(query);
        }}>
            <Label htmlFor={id}>Поиск по ID</Label>
            <div className="flex flex-wrap gap-2">
                <Input id={id} type="search" className="flex-1 min-w-0"
                    placeholder="Order ID мерчанта или ID системы"
                    value={draft} onChange={event => {
                        setDraft(event.target.value);
                        if (!event.target.value) onSearch('');
                    }} />
                <Button type="submit">Найти</Button>
                {(draft || value) && <Button type="button" variant="outline" onClick={() => {
                    setDraft('');
                    onSearch('');
                }}>Сбросить поиск</Button>}
            </div>
            <p className="text-xs text-gray-500 dark:text-slate-400">
                Вставьте ID.
            </p>
        </form>
    );
};
